import { useSearchParams } from 'react-router';
import useNumberParameter from './use-number-parameter';

const usePaginationValue = (): number => {
  const [searchParameters] = useSearchParams();
  return useNumberParameter({ searchParams: searchParameters, key: 'page', fallback: 1 });
};

export default usePaginationValue;
